import React, { useMemo } from 'react';
import { prefersReducedMotion } from '../hooks/useProgressFx';

const COLORS = ['#FF7800', '#94C2FF', '#FFFFFF', '#5CBE87', '#FFA44D'];
const COUNT = 26;

// Banner over baren og konfetti midt i avatar-gruppen (forælderen skal være position: relative).
export default function ProgressCelebrations({ banner, burstKey }) {
  const pieces = useMemo(() => {
    if (!burstKey || prefersReducedMotion()) return [];
    return Array.from({ length: COUNT }, (_, i) => {
      const angle = (i / COUNT) * Math.PI * 2 + Math.random() * 0.3;
      const dist = 70 + Math.random() * 110;
      return {
        i,
        dx: Math.cos(angle) * dist,
        dy: Math.sin(angle) * dist - 30,
        rot: (Math.random() * 2 - 1) * 360,
        dur: 800 + Math.random() * 500,
        delay: Math.random() * 90,
        color: COLORS[i % COLORS.length],
      };
    });
  }, [burstKey]);

  return (
    <>
      {pieces.map((p) => (
        <span
          key={`${burstKey}-${p.i}`}
          style={{
            position: 'absolute', left: '50%', top: '50%', width: 6, height: 11, borderRadius: 2,
            background: p.color, pointerEvents: 'none', zIndex: 3,
            '--dx': `${p.dx}px`, '--dy': `${p.dy}px`, '--rot': `${p.rot}deg`,
            animation: `zrmConfetti ${p.dur}ms cubic-bezier(.15,.6,.3,1) ${p.delay}ms forwards`,
          }}
        />
      ))}
      {banner && (
        <div key={banner.title} className="fixed inset-x-0 flex justify-center pointer-events-none" style={{ bottom: 112, zIndex: 2100 }}>
          <div
            role="status"
            className="bg-[#FF7800] text-[#0D1A27] rounded-lg text-center"
            style={{ padding: '10px 20px', animation: 'zrmPop .5s cubic-bezier(.2,1.4,.4,1)' }}
          >
            <div style={{ fontSize: 15, fontWeight: 700 }}>{banner.title}</div>
            <div style={{ fontSize: 12, fontWeight: 600, opacity: 0.8 }}>{banner.sub}</div>
          </div>
        </div>
      )}
    </>
  );
}
